import React from 'react';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useTranslation } from 'react-i18next';

const ImageUploader = ({
  dialogOpen,
  onDialogClose,
  onTakePhoto,
  onLibraryUpload
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      visible={dialogOpen}
      style={{
        width: "100%",
        maxWidth: "400px",
        position: "fixed",
        bottom: 0,
        margin: 0,
      }}
      modal
      onHide={onDialogClose}
      header={null}
      className="p-dialog-headerless"
      pt={{
        header: {
          style: {
            display: "none",
          },
        },
      }}
    >
      <div
        className="d-flex flex-column mb-2"
        style={{ 
          backgroundColor: "white",
          borderRadius: "12px",
          overflow: "hidden"
        }}
      >
        <Button
          label={`${t('common.takeAPhoto')}`}
          className="color-primary p-button-text w-100"
          style={{
            padding: "16px",
            margin: 0,
            borderRadius: 0,
            height: "48px"
          }}
          onClick={onTakePhoto}
        />
        <div
          style={{ height: "1px", background: "#E5E5E5" }}
        />
        <Button
          label={`${t('common.chooseFromLibrary')}`}
          className="p-button-text w-100"
          style={{
            padding: "16px",
            margin: 0,
            borderRadius: 0,
            height: "48px"
          }}
          onClick={onLibraryUpload}
        />
      </div>

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          overflow: "hidden"
        }}
      >
        <Button
          label={`${t('common.cancel')}`}
          className="p-button-text w-100"
          style={{
            padding: "16px",
            margin: 0,
            borderRadius: 0,
            height: "48px"
          }}
          onClick={onDialogClose}
        />
      </div>
    </Dialog>
  );
};

export default ImageUploader;
